import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import last from 'lodash/last';
import map from 'lodash/map';
import { DefaultOptionType, SingleValueType } from 'rc-cascader/lib/Cascader';
import Button from 'antd/lib/button/button';
import Cascader from 'antd/lib/cascader';
import Divider from 'antd/lib/divider';

import { categoriesSelector } from 'store/selectors/categoriesSelectors';
import { getCategoriesAction } from 'store/actions/categoriesActions';
import { bulkUpdateProductsAction, updateProductAction } from 'store/actions/listsActions';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { ProductsEditCategoriesStyled } from 'components/ProductsEditCategories/styled';
import { EEditType } from 'types/commonEnums';

interface IProductsEditCategoriesProps {
  ids: string[],
  isBulk?: boolean,
  onModalClose: () => void,
}

interface ICategory {
  categoryId: DefaultOptionType['value'];
  categoryName: DefaultOptionType['label'];
  categories: DefaultOptionType['value'][];
}

const ProductsEditCategories: FC<IProductsEditCategoriesProps> = ({ ids, isBulk, onModalClose }) => {
  const dispatch = useDispatch();
  const { isLoading, isUpdated, results } = useTypedSelector(categoriesSelector);
  const [category, setCategory] = useState<ICategory>({ categoryId: '', categoryName: '', categories: [] });

  const handleUpdate = async() => {
    const action = isBulk ? bulkUpdateProductsAction : updateProductAction;

    await dispatch(action({ ids, type: EEditType.Edit, ...category }));
    onModalClose();
  };

  const handleChange = (_: SingleValueType, selectedOptions: DefaultOptionType[]) => {
    const selectedCategory = last(selectedOptions);
    const { value: categoryId, label: categoryName } = selectedCategory || {};
    const categories = map(selectedOptions, 'value');

    setCategory({ categoryId, categoryName, categories });
  };

  useEffect(() => {
    !isUpdated && dispatch(getCategoriesAction());
  }, []);

  return (
    <ProductsEditCategoriesStyled>
      <h2 className="my-4">Change Category</h2>
      <Cascader
        size="large"
        loading={isLoading}
        className="min-w-full"
        options={results}
        placeholder="Select Category"
        displayRender={last}
        onChange={handleChange}
      />
      <Divider />
      <Button
        size="large"
        type="primary"
        disabled={!category.categoryId && !category.categoryName}
        className="block ml-auto"
        onClick={handleUpdate}
      >
        Done
      </Button>
    </ProductsEditCategoriesStyled>
  );
};

export default ProductsEditCategories;
